import { StartWizardRoutingModule } from './start-wizard-routing.module';
import { WizardSecondComponent } from '@/start-wizard/components/wizard-second/wizard-second.component';
import { WizardFirstComponent } from './components/wizard-first/wizard-first.component';
import { WizardThirdComponent } from './components/wizard-third/wizard-third.component';
import { StepsComponent } from './components/steps/steps.component';
import { WizardComponent } from './components/wizard.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DividerModule } from 'primeng/divider';
import { FormsModule } from '@angular/forms';
import { MessageModule } from 'primeng/message';
import { PasswordModule } from 'primeng/password';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { ProgressBarModule } from 'primeng/progressbar';
import { InputText } from 'primeng/inputtext';
import { TranslatePipe } from '@ngx-translate/core';

@NgModule({
    declarations: [WizardComponent, StepsComponent, WizardFirstComponent, WizardSecondComponent, WizardThirdComponent],
    imports: [
        DividerModule,
        FormsModule,
        MessageModule,
        PasswordModule,
        ButtonModule,
        SelectModule,
        ProgressBarModule,
        CommonModule,
        StartWizardRoutingModule,
        InputText,
        TranslatePipe,
    ],
    exports: [WizardComponent],
})
export class StartWizardModule {}
